import type { SVGProps } from 'react';

const SvgLinkAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m11.285 15.295-.66.66c-.24.23-2.38 2.2-4.58 0s-.23-4.35 0-4.58l.67-.67a.996.996 0 1 0-1.41-1.41l-.67.67c-1.28 1.28-2.93 4.48 0 7.4 1.2 1.2 2.45 1.63 3.6 1.63 1.64 0 3.05-.88 3.81-1.63l.67-.67a.996.996 0 1 0-1.41-1.41zm4-4a.996.996 0 0 0 0 1.41c.2.19.45.29.71.29s.51-.1.71-.29l.67-.67c1.28-1.28 2.93-4.48 0-7.4-2.93-2.93-6.12-1.28-7.4 0l-.67.67a.996.996 0 1 0 1.41 1.41l.66-.66c.24-.23 2.38-2.2 4.58 0s.23 4.35 0 4.58l-.67.67z"
    />
    <path
      fill="currentcolor"
      d="m12.285 8.305-3.99 3.99a.996.996 0 0 0 0 1.41c.2.19.45.29.71.29s.51-.1.71-.29l3.99-3.99a.996.996 0 1 0-1.41-1.41zm7.71 8.7h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgLinkAdd;
